module.exports = __webpack_public_path__ + "static/media/list.9b58e10a.svg";